import { DEFAULT_BIG_DIALOG_WIDTH } from '@abb-procure/constants';
import { RequirementFields } from '@abb-procure/data';
import { Overlay } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type {
  RequirementsSettingsDialog,
  RequirementsSettingsDialogData,
} from '../components/requirements-settings-dialog/requirements-settings-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class RequirementsSettingsDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly overlay = inject(Overlay);

  async openRequirementsSettingsDialog(
    name: string,
    requirementFields: RequirementFields,
    control: FormControl,
    formFields: { [key: string]: string },
  ): Promise<MatDialogRef<RequirementsSettingsDialog, RequirementFields>> {
    const module =
      await import('../components/requirements-settings-dialog/requirements-settings-dialog.component');

    const dialog = this.dialog.open<
      RequirementsSettingsDialog,
      RequirementsSettingsDialogData,
      RequirementFields
    >(module.RequirementsSettingsDialog, {
      width: DEFAULT_BIG_DIALOG_WIDTH,
      data: {
        name,
        requirementFields,
        control,
        formFields,
      },
      panelClass: ['requirements-settings-dialog'],
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    return dialog;
  }
}
